/** @format */

import React from 'react';
import SuperAgent from 'superagent';
import update from 'immutability-helper';
import {
    PAYMENT_ACCOUNT_TYPE_ECHECK,
    PAYMENT_PROFILE_TYPE_BANK,
    PAYMENT_PROFILE_TYPE_CREDIT
} from 'frontier-constants';
import {UserContext} from 'frontier-utilities';
import creditCardType from 'credit-card-type';

export default function withPaymentsHandler(ComponentContainer) {
    return class extends React.Component {
        static propTypes = {};
        static contextType = UserContext;

        constructor(props) {
            super(props);
            this.state = {
                error: false,
                pending: false, // Are we trying to save
                loading: false, // Are we loading new shipping methods
                paymentProfiles: [],
                formData: {},
                paymentMethodTypeId: false
            };
        }

        componentDidMount() {
            this.handleGetPaymentProfiles();
        }

        handleGetPaymentProfiles = () => {
            this.setState({
                loading: true
            });

            SuperAgent.get('/account/users/get-payment-profiles')
                .set('Accept', 'application/json')
                .end((err, response) => {
                    this.setState({
                        loading: false,
                        paymentProfiles: response.body
                    });
                });
        };

        handleChange = updateTarget => {
            this.setState(update(this.state, updateTarget));
        };

        handleSavePaymentProfile = ({response, cardData, bankData, paymentType}) => {
            this.setState({
                error: false,
                saving: true
            });

            let url = '/account/users/save-nonce-payment-profile';

            const formData = {...this.state.formData};
            formData.billing_address_id = this.props.billing_address_id;
            if (
                this.state.paymentMethodTypeId === PAYMENT_PROFILE_TYPE_BANK ||
                paymentType === PAYMENT_PROFILE_TYPE_BANK
            ) {
                formData.account_type_id = PAYMENT_ACCOUNT_TYPE_ECHECK;
            }

            if (response?.opaqueData) {
                formData.opaqueData = response?.opaqueData;
            }

            if (
                this.state.paymentMethodTypeId === PAYMENT_PROFILE_TYPE_CREDIT ||
                formData.card_code
            ) {
                const cardTypeNow = creditCardType(formData.account_number);
                formData.card_type = cardTypeNow?.[0]?.niceType;
            }

            formData.account_number = formData.account_number.trim().slice(-4);

            SuperAgent.post(url)
                .set('Accept', 'application/json')
                .send(formData)
                .end((err, response) => {
                    if (err || !response.body) {
                        this.setState({
                            error: response ? response.body : err,
                            saving: false
                        });
                    } else {
                        this.setState(
                            {
                                saving: false,
                                formData: {}
                            },
                            this.handleGetPaymentProfiles
                        );
                    }
                });
        };

        handleRemove = profileId => {
            SuperAgent.delete('/account/users/disable-payment-profile/' + profileId)
                .set('Accept', 'application/json')
                .end(() => {
                    const profileIndex = this.state.paymentProfiles.findIndex(
                        profile => profile.id == profileId
                    );

                    const updateTarget = {paymentProfiles: {$splice: [[profileIndex, 1]]}};
                    this.setState(update(this.state, updateTarget));
                });
        };

        isSaving = () => {
            this.setState({
                error: false,
                saving: true
            });
        };

        render() {
            const props = {...this.props};
            props.onGetPaymentProfiles = this.handleGetPaymentProfiles;
            props.onSavePaymentProfile = this.handleSavePaymentProfile;
            props.onChange = this.handleChange;
            props.onRemove = this.handleRemove;
            props.isSaving = this.isSaving;

            return <ComponentContainer {...props} {...this.state} context={this.context} />;
        }
    };
}
